import { defineStore } from 'pinia'

const STORAGE_KEY = 'cabinet-customer-session'

interface SessionState {
  customerId: string
  phone: string
  accessToken: string
}

function readSession(): SessionState {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const parsed = JSON.parse(stored) as Partial<SessionState>
      return {
        customerId: parsed.customerId || '',
        phone: parsed.phone || '',
        accessToken: parsed.accessToken || '',
      }
    }
  } catch {
    localStorage.removeItem(STORAGE_KEY)
  }
  return { customerId: '', phone: '', accessToken: '' }
}

export const useSessionStore = defineStore('session', {
  state: (): SessionState => readSession(),
  getters: {
    isAuthenticated: (state) => Boolean(state.customerId && state.phone && state.accessToken),
    maskedPhone: (state) =>
      state.phone ? `${state.phone.slice(0, 3)}****${state.phone.slice(-4)}` : '',
  },
  actions: {
    signIn(customerId: string, phone: string, accessToken: string) {
      this.customerId = customerId
      this.phone = phone
      this.accessToken = accessToken
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ customerId, phone, accessToken }))
    },
    signOut() {
      this.customerId = ''
      this.phone = ''
      this.accessToken = ''
      localStorage.removeItem(STORAGE_KEY)
    },
  },
})
